/**
 * @file src/components/Navbar.js
 * @description Top navigation bar.
 *
 * The navbar renders auth-aware links:
 * - Logged out: Home, About, Library (read-only), Login, Register
 * - Logged in : Home, About, Library, Logout
 */

const Navbar = () => {
  const isLoggedIn = Boolean(localStorage.getItem("token"));
  const username = localStorage.getItem("username") || "";

  return `
    <nav class="navbar">
      <h2 class="logo">ShelfQuest Digital Library</h2>

      <button class="menu-icon" aria-label="Open menu" onclick="toggleMenu(this)">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul class="nav_links">
        <li><a href="#" onclick="navigateTo('home')">Home</a></li>
        <li><a href="#" onclick="navigateTo('about')">About</a></li>
        <li><a href="#" onclick="navigateTo('library')">Library</a></li>

        ${isLoggedIn
          ? `
            <li class="nav_user">Hi, ${username || "User"}</li>
            <li><a href="#" onclick="logout()">Logout</a></li>
          `
          : `
            <li><a href="#" onclick="navigateTo('login')">Login</a></li>
            <li><a href="#" onclick="navigateTo('register')">Register</a></li>
          `
        }
      </ul>
    </nav>
  `;
};

export default Navbar;
